export const useAvailableBlockKeys = (block_schema) => {
  let schema_mapped = block_schema?.schema
    ?.map((row) => row?.columns?.map((col) => col?.map((item) => item?.block)))
    .flat();

  return schema_mapped?.flat();
};
